import { Collapse } from '@mui/material';
import { TransitionGroup } from 'react-transition-group';
import AttachedLabel from './AttachedLabel';
import { useLabelAttachmentsStore } from './labelAttachments.store';
import ShowMoreLabels from './ShowMoreLabels';
import useLabelStoreHydration from './useLabelStoreHydration';

function LabelStoreHydration() {
  const attachedTo = useLabelAttachmentsStore((state) => state.attachLabelsTo);
  useLabelStoreHydration(attachedTo);
  return null;
}

export default function LabelGroup({ canEdit, hydrateLabels = true }) {
  const labels = useLabelAttachmentsStore((state) => state.labels);

  const maxLabels = 5; // TODO: Update this to be dynamic based on width of labels
  const labelsToShow = labels.slice(0, maxLabels);
  const hiddenLabels = labels.slice(maxLabels);

  return (
    <div className="flex items-center">
      {hydrateLabels && <LabelStoreHydration />}
      <TransitionGroup component={null}>
        {labelsToShow.map((label) => (
          <Collapse orientation="horizontal" key={label.labelDefinition.label}>
            <AttachedLabel {...label} canEdit={canEdit} />
          </Collapse>
        ))}
        <ShowMoreLabels key="showLabels" hiddenLabels={hiddenLabels} canEdit={canEdit} />
      </TransitionGroup>
    </div>
  );
}
